<template>
  <div v-show="$store.state.modal" class="modal" @click.self="$store.commit('hideModal')">
    <div class="modal__inner">
      <close class="close" @click="$store.commit('hideModal')"/>
      <contact modal/>
    </div>
  </div>
</template>

<script>
import Contact from './section-contact';
import Close from './close';

export default {
  components: { Contact, Close },
}
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);

  &__inner {
    position: relative;
    max-height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    @include mobile {
      height: 100%;
    }
  }

  .close {
    position: absolute;
    z-index: 1;

    @include mobile {
      top: 5px;
      right: 20px;
      color: #fff;
    }

    @include desktop {
      top: 30px;
      right: 40px;
      color: #9a9898;
    }
  }

  ::v-deep .left,
  ::v-deep .right {
    @include desktop {
      padding: 0 40px;
    }
  }

  ::v-deep form {
    margin: auto;
  }
}
</style>